interface LogoProps {
    variant?: "color" | "dark" | "light"
    className?: string
    height?: number
}

export const Logo = ({ variant = "color", className, height = 32 }: LogoProps) => {
    const textFill = variant === "light" ? "#ffffff" : "var(--color-charcoal)"
    const iFill = variant === "color" ? "var(--color-brand)" : textFill
    const dotFill = iFill

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 400 120"
            height={height}
            className={className}
            role="img"
            aria-label="Kempi"
        >
            <text
                x="20"
                y="85"
                fontFamily="system-ui, -apple-system, 'Segoe UI', sans-serif"
                fontSize="80"
                fontWeight="900"
                fill={textFill}
                letterSpacing="-2"
            >
                Kemp<tspan fill={iFill}>i</tspan>
            </text>
            <circle cx="248" cy="22" r="8" fill={dotFill} />
        </svg>
    )
}
